<template>
  <div>
    <div class="sign-content">
      <!--联系信息 -->
      <el-card-title :title="title" />
      <el-form label-width="80px" :model="legalPersonForm" :rules="legalPersonFormRules" ref="legalPersonFormRef" class="endItem">
        <el-form-item :label="$t('page.contactInfo.contentLabel.legalName')" label-width="400px" :prop="isChinese === 'zh-cn' ? 'legalContactName': ''">     <!-- 法人代表姓名 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.legalNameMsg')" v-model="legalPersonForm.legalContactName" :disabled="isSkyEyes" show-word-limit maxlength="25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.legalMobile')" label-width="400px" prop="legalContactMobile" v-if="isChinese === 'zh-cn'">     <!-- 法人代表手机 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.legalMobileMsg')" v-model="legalPersonForm.legalContactMobile" show-word-limit  maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.legalTel')" label-width="400px"  v-if="isChinese === 'zh-cn'" prop="legalContactTel">     <!-- 法人代表固定电话 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.legalTelMsg')" v-model="legalPersonForm.legalContactTel" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.legalID')" label-width="400px" prop="legalContactIdcard" v-if="isChinese === 'zh-cn'">     <!-- 法人代表身份证号/境外社保号 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.legalID')" v-model="legalPersonForm.legalContactIdcard" show-word-limit maxlength="18"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.legalFax')" label-width="400px"  v-if="isChinese === 'zh-cn'">     <!-- 法人代表传真 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.legalFaxMsg')" v-model="legalPersonForm.legalContactFax" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.legalEmail')" label-width="400px" prop="legalContactEmail" v-if="isChinese === 'zh-cn'">     <!-- 法人代表E-mail -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.legalEmailMsg')" v-model="legalPersonForm.legalContactEmail" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.market')" label-width="400px" :prop="isChinese === 'zh-cn' ? 'salesHeaderName': ''" class="endItem">      <!-- 销售负责人 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.marketMsg')" v-model="legalPersonForm.salesHeaderName" show-word-limit maxlength="25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.marketMobile')" label-width="400px" :prop="isChinese === 'zh-cn' ? 'salesHeaderMobile': ''">     <!-- 销售负责人手机 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.marketMobileMsg')" v-model="legalPersonForm.salesHeaderMobile" show-word-limit  :maxlength="isChinese === 'zh-cn'?11:25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.marketTel')" label-width="400px" prop="salesHeaderTel">      <!-- 销售负责人固定电话 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.marketTelMsg')" v-model="legalPersonForm.salesHeaderTel" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.saleID')" label-width="400px" prop="salesHeaderIdcard" v-if="languagezh_cn">      <!-- 销售负责人身份证号/境外社保号 -->
          <el-input class="IDplac" :placeholder="$t('page.contactInfo.inputPlc.saleID')" v-model="legalPersonForm.salesHeaderIdcard" show-word-limit maxlength="18"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.marketFax')" label-width="400px">     <!-- 销售负责人传真 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.marketFaxMsg')" v-model="legalPersonForm.salesHeaderFax" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.marketEmail')" label-width="400px" :prop="isChinese === 'zh-cn' ? 'salesHeaderEmail': ''">     <!-- 销售负责人E-mail -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.marketEmailMsg')" v-model="legalPersonForm.salesHeaderEmail" maxlength="320"></el-input>
        </el-form-item>
        <el-form-item :label="$t('page.contactInfo.contentLabel.web')" label-width="400px">     <!-- 公司网址 -->
          <el-input :placeholder="$t('page.contactInfo.inputPlc.webMsg')" v-model="legalPersonForm.website" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <!--实控主体 -->
      <el-card-title :title="$t('page.contactInfo.contentLabel.controlAgent')"  v-if="languagezh_cn"/>
      <div style="width: 94%; margin-top: 40px; margin-bottom: 40px;"  v-if="languagezh_cn">
         <div style="text-align: right; margin-bottom: 10px;">
            <el-button plain type="single-number" class="myBtn" @click="addLine(1)">
                {{$t('page.productInfo.btn.newAdd')}}
            </el-button>
            <el-button plain type="single-number" class="myBtn" @click="deleteRow(1)">
              {{$t('page.productInfo.btn.del')}}
            </el-button>
         </div>
        <el-table
          ref="multipleTable"
          widthResize
          :data="mainstayTableData"
          :header-cell-class-name="must"
          class="multifunctional-table"
          style="width: 830px; margin-left: 280px;"
          border
          :max-height="99999"
          show-overflow
          @select="handleCheckChange"
          @select-all="handleCheckAllChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            type="index"
            :label="$t('page.contactInfo.contentLabel.xuhao')"
            min-width="50"
          >
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.controlType')"
            prop="mainstayTypename"
            width="180"
            show-overflow-tooltip
          >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.mainstayTypename"
                  :placeholder="$t('page.supInfo.inputPlc.choose')"
                  @change="getSelect(scope.row, 1)"
                >
                  <el-option
                    v-for="item in mainstayTypename"
                    :key="item.dicKey"
                    :label="item.dicValue"
                    :value="item.dicValue"
                  >
                  </el-option>
                </el-select>
              </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.controlAgent')"
            prop="mainstayName"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                :key="scope.rowIndex"
                v-model.trim="scope.row.mainstayName"
                maxlength="100"
                :placeholder="$t('page.supInfo.inputPlc.input')"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.controlId')"
            prop="mainstayIdcard"
            width="330"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                @input="invaildCard(scope.row,'mainstayIdcard')"
                :key="scope.rowIndex"
                v-model.trim="scope.row.mainstayIdcard"
                :placeholder="$t('page.supInfo.inputPlc.input')"
                maxlength="18"
                show-word-limit
              >
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--董监高 -->
      <el-card-title :title="$t('page.contactInfo.contentLabel.DJG')"   v-if="languagezh_cn"/>
      <div style="width: 94%; margin-top: 40px; margin-bottom: 30px;"  v-if="languagezh_cn">
         <div style="text-align: right; margin-bottom: 10px;">
            <el-button plain type="single-number" class="myBtn" @click="addLine(2)" >
              {{$t('page.productInfo.btn.newAdd')}}
            </el-button>
            <el-button plain type="single-number" class="myBtn" @click="deleteRow(2)">
              {{$t('page.productInfo.btn.del')}}
            </el-button>
         </div>
        <el-table
          ref="multipleTable"
          widthResize
          :data="djgTableData"
          :header-cell-class-name="must"
          class="multifunctional-table"
          style="width: 830px; margin-left: 280px;"
          border
          :max-height="99999"
          show-overflow
          @select="handleCheckChange1"
          @select-all="handleCheckAllChange1"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            type="index"
            :label="$t('page.contactInfo.contentLabel.xuhao')"
            min-width="50"
          >
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.DJGT')"
            prop="djgTypename"
            width="180"
            show-overflow-tooltip
          >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.djgTypename"
                  :placeholder="$t('page.supInfo.inputPlc.choose')"
                  @change="getSelect(scope.row, 2)"
                >
                  <el-option
                    v-for="item in djgTypename"
                    :key="item.dicKey"
                    :label="item.dicValue"
                    :value="item.dicValue"
                  >
                  </el-option>
                </el-select>
              </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.DJGN')"
            prop="djgName"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                :key="scope.rowIndex"
                v-model.trim="scope.row.djgName"
                maxlength="100"
                :placeholder="$t('page.supInfo.inputPlc.input')"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.contactInfo.contentLabel.DJGID')"
            prop="djgIdcard"
            width="330"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-input
                :key="scope.rowIndex"
                @input="invaildCard(scope.row,'djgIdcard')"
                v-model.trim="scope.row.djgIdcard"
                :placeholder="$t('page.supInfo.inputPlc.input')"
                maxlength="18"
                show-word-limit
              >
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="back()"
      >
        <span>{{ $t('basicLayout.btn')[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t('basicLayout.btn')[1] }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import {saveSupplierRegistInfo,qrySupRegistContactInfo,qryDictByCode} from '@/api/supRegister'
import {mapActions} from 'vuex'
import Setting from "@/config/index";
import Cookies from "js-cookie";
import { generateUUID } from "@/utils";
const savedLocaleKey = Setting.i18n.cookieLable;
export default {
  name: "contactInformation",
  data() {
    return {
      title: window.$t('page.contactInfo.contentTitle.contactsInfo'),     // 联系信息
      // 表单数据
      legalPersonForm: {
        legalContactName:'',
        legalContactMobile: '',
        legalContactTel: '',
        legalContactFax: '',
        legalContactEmail: '',
        salesHeaderName: '',
        salesHeaderMobile: '',
        salesHeaderTel: '',
        salesHeaderFax: '',
        salesHeaderEmail: '',
        website: '',
        legalContactIdcard: '',
        salesHeaderIdcard: ''
      },
      // 表单校验规则
      legalPersonFormRules: {
        legalContactName: [{ required: true, message: window.$t('page.contactInfo.inputPlc.legalNameMsg'), trigger: 'blur' }],
        legalContactMobile: [{ required: true, message: window.$t('page.contactInfo.inputPlc.legalMobileMsg'), trigger: 'blur' },
          {pattern: /^1[3456789]\d{9}$/, message: window.$t('page.contactInfo.inputRules.mobileMsg'),trigger: 'blur' }],
        legalContactTel: [{ required: false, message: window.$t('page.contactInfo.inputPlc.legalTelMsg'), trigger: 'blur' },
          {pattern:/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,message: window.$t('page.contactInfo.inputRules.legalTelMsg'),trigger: 'blur'}],
        // 如果点击下一步还需要验证，则在事件加入正则验证
         legalContactFax: [{  message: window.$t('page.contactInfo.inputPlc.legalFaxMsg'), trigger: 'blur' },
          {pattern:/^(\d{3,4}-)?\d{7,8}$/,message: window.$t('page.contactInfo.inputRules.legalFaxMsg'),trigger: 'blur'}
          ],
        legalContactEmail: [{  required:true,message: window.$t('page.contactInfo.inputPlc.legalEmailMsg'), trigger: 'blur' },
          {pattern:/\@/,message: window.$t('page.contactInfo.inputRules.emailMsg'),trigger: 'blur'},
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: window.$t('page.contactInfo.inputRules.emailMsg'),
            trigger: "blur"
          }],
        salesHeaderName: [{ required: true, message: window.$t('page.contactInfo.inputPlc.marketMsg'), trigger: 'blur' }],
        salesHeaderMobile: [{ required: true, message: window.$t('page.contactInfo.inputPlc.marketMobileMsg'), trigger: 'blur' },
          {pattern: /^1[3456789]\d{9}$/, message: window.$t('page.contactInfo.inputRules.mobileMsg'),trigger: 'blur' }],
        salesHeaderTel: [{ required: false, message: window.$t('page.contactInfo.inputPlc.marketTelMsg'), trigger: 'blur' },
          {pattern:/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,message: window.$t('page.contactInfo.inputRules.marketTelMsg'),trigger: 'blur'}],
        salesHeaderFax: [{ required: true, message: window.$t('page.contactInfo.inputPlc.marketFaxMsg'), trigger: 'blur' },
          {pattern:/^(\d{3,4}-)?\d{7,8}$/,message: window.$t('page.contactInfo.inputRules.marketFaxMsg'),trigger: 'blur'}],
        salesHeaderEmail: [{ required: true, message: window.$t('page.contactInfo.inputPlc.marketEmailMsg'), trigger: 'blur' },
          {pattern:/\@/,message: window.$t('page.contactInfo.inputRules.emailMsg'),trigger: 'blur'},
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: window.$t('page.contactInfo.inputRules.emailMsg'),
            trigger: "blur"
          }],
        legalContactIdcard: [{ required: true, message: '请输入法人代表身份证号/境外社保号', trigger: 'blur' }],
        salesHeaderIdcard: [{ required: true, message: window.$t('page.contactInfo.inputPlc.saleID'), trigger: 'blur' }],
      },
      supInfoApplyId: '',
      isSkyEyes: false,  // 是否天眼查
      isChinese: Cookies.get(savedLocaleKey) || 'zh-cn',
      //实控主体
      mainstayTableData: [],
      //实控主体-类型
      mainstayTypename: [],
      //实控主体-选中的数据
      selectVal: [],
      //董监高
      djgTableData: [],
      //董监高-类型
      djgTypename: [],
      //董监高-选中的数据
      selectVal1: []
    }
  },
  watch:{
    "legalPersonForm.legalContactIdcard"(newValue, oldValue) {
      this.legalPersonForm.legalContactIdcard = newValue.replace(/[\W]/g, "");
    },
    "legalPersonForm.salesHeaderIdcard"(newValue, oldValue) {
      this.legalPersonForm.salesHeaderIdcard = newValue.replace(/[\W]/g, "");
    },
  },
  created() {
    if(this.$route.query.page) {
      this.changeCheckPage(5)
    }
    if(Cookies.get('access_token') || this.$route.query.tempSupinfoId){
      this.getSupRegistContactInfo()
    }
    if(this.isChinese !== 'zh-cn') {
      this.legalPersonFormRules.salesHeaderTel = []
      this.legalPersonFormRules.salesHeaderFax = []
      this.legalPersonFormRules.salesHeaderMobile = []
    }
    if(this.$route.path == '/maPerfectInfo/contactInformation'){
      this.changeCheckPage(5);
      for(let i = 0; i < 2; i++){
        this.msgCenter.$emit('ballMoveRight')
      }
    }

    this.qryDictByCode("SMPC_MAINSTAY_TYPE"); //实控主体字典
    this.qryDictByCode("SMPC_DJG_TYPE");  //董监高字典
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    invaildCard(row, prop) {
      if (prop == "mainstayIdcard") {
        if (row.id) {
          let index = this.mainstayTableData.findIndex(i => i.id == row.id);
          this.mainstayTableData[index].mainstayIdcard = this.mainstayTableData[
            index
          ].mainstayIdcard.replace(/[\W]/g, "");
        } else if (row.mainstayId) {
          let index = this.mainstayTableData.findIndex(i => i.mainstayId == row.mainstayId);
          this.mainstayTableData[index].mainstayIdcard = this.mainstayTableData[
            index
          ].mainstayIdcard.replace(/[\W]/g, "");
        }
      } else if (prop == "djgIdcard") {
        if (row.id) {
          let index = this.djgTableData.findIndex(i => i.id == row.id);
          this.djgTableData[index].djgIdcard = this.djgTableData[index].djgIdcard.replace(
            /[\W]/g,
            ""
          );
        } else if (row.djgId) {
          let index = this.djgTableData.findIndex(i => i.djgId == row.djgId);
          this.djgTableData[index].djgIdcard = this.djgTableData[index].djgIdcard.replace(
            /[\W]/g,
            ""
          );
        }
      }
    },
    back() {
      this.changeCheckPage(4)
      this.$router.push({path:'/maPerfectInfo/basicInformation',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
    },
    next() {
      this.$refs.legalPersonFormRef.validate(async valid => {
        if(valid) {
          let msg = this.mainstaySubmit();
          if(msg){
            this.$message({
              showClose: true,
              type: "error",
              message: msg,
              ccuiCustom: true,
            })
            return
          }
          let msg1 = this.djgSubmit();
          if(msg1){
            this.$message({
              showClose: true,
              type: "error",
              message: msg1,
              ccuiCustom: true,
            })
            return
          }
          try {
            const {data} = await saveSupplierRegistInfo({
              dataSourceFlag: 0,
              isShowLoading:true,
              isOverseas: window.languagezh_cn?0:1,
              tempSupinfoId: this.supInfoApplyId,
              // supCode: '',
              saveOrCommitFlag: '2',
              supRegistTab: '6',
              // supRegistAccountInfoBO:{
              //   countyCode:sessionStorage.getItem('countyCode'),
              //   countyName:sessionStorage.getItem('countyName'),
              // },
              supRegistContactInfoBO: Object.assign(this.legalPersonForm,{ "supTempMainstayInfoBOS": this.mainstayTableData , "supTempDjgInfoBOS": this.djgTableData})
            })
            console.log(data)
            if(data.code ==0) {
              this.changeCheckPage(6)
              this.$router.push({
                path:'/maPerfectInfo/productInformation',
                query: {tempSupinfoId: this.$route.query.tempSupinfoId}
              })
            }
          } catch (err) {
            console.log(err.data.message)
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName('is-error');
            isError[0].querySelector('input').focus();
          },100)
          return false
        }
      })
    },
    async getSupRegistContactInfo() {
      try {
        const {data} = await qrySupRegistContactInfo({
          tempOrFormalFlag: this.$route.query.tempOrFormalFlag?this.$route.query.tempOrFormalFlag:0,
          supInfoApplyId: this.$route.query.tempSupinfoId,
          isShowLoading:true,
        })
        console.log(data)
        if(data.code === '0') {

          this.tycInfo = data.data.tycInfo?JSON.parse(data.data.tycInfo):{};
          console.log("天眼查数据",this.tycInfo)
          this.isSkyEyes = false;
          if(this.tycInfo.legalContactName != ''&&this.tycInfo.legalContactName != undefined) {
            this.isSkyEyes = true
          }
          this.legalPersonForm.legalContactName = data.data.supRegistContactInfoBO.legalContactName
          this.legalPersonForm.legalContactMobile = data.data.supRegistContactInfoBO.legalContactMobile
          this.legalPersonForm.legalContactTel = data.data.supRegistContactInfoBO.legalContactTel
          this.legalPersonForm.legalContactFax = data.data.supRegistContactInfoBO.legalContactFax
          this.legalPersonForm.legalContactEmail = data.data.supRegistContactInfoBO.legalContactEmail
          this.legalPersonForm.salesHeaderName = data.data.supRegistContactInfoBO.salesHeaderName
          this.legalPersonForm.salesHeaderMobile = data.data.supRegistContactInfoBO.salesHeaderMobile
          this.legalPersonForm.salesHeaderTel = data.data.supRegistContactInfoBO.salesHeaderTel
          this.legalPersonForm.salesHeaderFax = data.data.supRegistContactInfoBO.salesHeaderFax
          this.legalPersonForm.salesHeaderEmail = data.data.supRegistContactInfoBO.salesHeaderEmail
          this.legalPersonForm.website = data.data.supRegistContactInfoBO.website
          this.legalPersonForm.legalContactIdcard = data.data.supRegistContactInfoBO.legalContactIdcard
          this.legalPersonForm.salesHeaderIdcard = data.data.supRegistContactInfoBO.salesHeaderIdcard
          this.supInfoApplyId = data.data.supInfoApplyId
          this.mainstayTableData = data.data.supRegistContactInfoBO.supTempMainstayInfoBOS || [];
          this.djgTableData = data.data.supRegistContactInfoBO.supTempDjgInfoBOS || [];
        }
      } catch (err) {
        console.log(err.data.message)
      }
    },
    must(obj){
      if(["mainstayTypename","mainstayName","mainstayIdcard","djgTypename","djgName","djgIdcard"].includes(obj.column.property)){
        return "must";
      }
    },
    //新增行
    addLine(type){
      if(type === 1){
        this.mainstayTableData.push(
          {
            id: generateUUID(),
            mainstayType: "",
            mainstayTypename: "",
            mainstayName: "",
            mainstayIdcard: ""
          }
        );
      } else {
        this.djgTableData.push(
          {
            id: generateUUID(),
            djgType: "",
            djgTypename: "",
            djgName: "",
            djgIdcard: ""
          }
        );
      }
    },
    //删除行
    deleteRow(type){
      let val = type === 1? this.selectVal : this.selectVal1,
          flagId = "",ids = [];
      if (val.length == 0) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请至少选择一项",
          ccuiCustom: true,
        })
        return;
      }
      console.log("3214332",type,val,this.mainstayTableData,this.djgTableData)
      
      // const ids = val.map(v => v.id);
      if(val[0].id){
        ids = val.map(v => v.id);
        flagId="id";
        console.log("1")
      }else if(val[0].mainstayId){
        ids = val.map(v => v.mainstayId);
        flagId="mainstayId";
        console.log("2")
      }else if(val[0].djgId){
        ids = val.map(v => v.djgId);
        flagId="djgId";
        console.log("3")
      }
      if(type === 1){
        this.mainstayTableData = this.mainstayTableData.filter(v => {
          return !ids.includes(v[flagId]);
        });
      } else {
        this.djgTableData = this.djgTableData.filter(v => {
          return !ids.includes(v[flagId]);
        });
      }
    },
    handleCheckChange(val){
      this.selectVal = val;
    },
    handleCheckAllChange(val) {
      this.selectVal = val;
    },
    handleCheckChange1(val){
      this.selectVal1 = val;
    },
    handleCheckAllChange1(val) {
      this.selectVal1 = val;
    },
    // 获取字典
    async qryDictByCode(code) {
      try {
        const { data } = await qryDictByCode({ code:code })
        if(data.code === '0') {
          if(code === "SMPC_MAINSTAY_TYPE"){
            this.mainstayTypename = data.data
          } else {
            this.djgTypename = data.data
          }

        }
      } catch (err) {
        console.log(err.message)
      }
    },
    getSelect(row, type){
      if(type === 1){
        this.$set(row, "mainstayTypename", row.mainstayTypename);
        this.mainstayTypename.forEach(e => {
          if (e.dicValue == row.mainstayTypename) {
            this.$set(row, "mainstayType", e.dicKey);
          }
        });
      } else {
        this.$set(row, "djgTypename", row.djgTypename);
        this.djgTypename.forEach(e => {
          if (e.dicValue == row.djgTypename) {
            this.$set(row, "djgType", e.dicKey);
          }
        });
      }
    },
    //实控主体-非空校验
    mainstaySubmit(){
      if(window.languagezh_cn&&this.mainstayTableData.length == 0){
        return `请添加实控主体信息`;
      }
      for(let i=0;i< this.mainstayTableData.length;i++){
        let v = this.mainstayTableData[i];
        if(!v.mainstayType){
          return `实控主体-第${i + 1}行, 实控类型代码不能为空`;
        }
        if(!v.mainstayTypename){
          return `实控主体-第${i + 1}行, 实控类型不能为空`;
        }
        if(!v.mainstayName){
          return `实控主体-第${i + 1}行, 实控主体不能为空`;
        }
        if(!v.mainstayIdcard){
          return `实控主体-第${i + 1}行, 控制主体代码或证件号不能为空`;
        }
      }
    },
    //董监高-非空校验
    djgSubmit(){
      if(window.languagezh_cn&&this.djgTableData.length == 0){
        return `请添加董监高信息`;
      }
      for(let i=0;i< this.djgTableData.length;i++){
        let v = this.djgTableData[i];
        if(!v.djgType){
          return `董监高-第${i + 1}行, 董监高类型代码不能为空`;
        }
        if(!v.djgTypename){
          return `董监高-第${i + 1}行, 董监高类型不能为空`;
        }
        if(!v.djgName){
          return `董监高-第${i + 1}行, 董监高人员姓名不能为空`;
        }
        if(!v.djgIdcard){
          return `董监高-第${i + 1}行, 董监高人员证件号不能为空`;
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
 .endItem ::v-deep .el-input__inner{
  padding-right: 67px;
}
  /deep/th .cell{
    word-break: break-word!important;
  }
.sign-content {
  width: 1180px;
  background: #FFFFFF;
  margin: 20px auto;
  overflow: hidden;

  .el-card-title {
    /deep/ .details-title {
      color: black;
      border-bottom: 0px;
      top: 20px;
      margin-left: 230px;
    }
  }
  .el-form {
    //margin-left: 214px;
    margin-top: 20px;
    .el-form-item .el-input {
      margin-left: 6px;
      width: 430px;
    }
    .el-form-item .el-form-item__label {
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #4A4A4A;
      text-align: right;
      line-height: 18px;
      font-weight: 400;
    }
  }

  /deep/.el-table .el-table__body-wrapper .el-table__body tr td {
    height: 36px;
  }
}
.btn {
  width: 240px;
  height: 40px;
  background: #FF142F;
  margin-bottom: 20px;
  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}
.btnBox {
  margin: 0px auto;
  width: 500px;
}
/deep/.myBtn{
  background: none;
  span{
    color: #FF142F;
  }
}
/deep/.el-button.el-button--single-number{
  border: 1px solid #FF142F;
  &:hover{
    border: 1px solid #FF142F;
  }
}
  /deep/.IDplac input{
    padding-right:45px
  }
  /deep/ .el-table--border {
    th:last-of-type.gutter {
      display: table-cell !important;
      width: 0px !important;
    }
  }
</style>
